<template>
  <v-expansion-panels
    v-model="panels"
    :multiple="model.Multiple"
  >
    <v-expansion-panel
      v-for="(panelItem, index) in panelItems"
      :key="index"
    >
      <v-expansion-panel-header>
        <div>
          <v-icon v-if="panelItem.IconName" :color="panelItem.IconColor">{{ panelItem.IconName }}</v-icon>
          {{ panelItem.Text }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <component
          v-for="widget in panelItem.Widgets || []"
          :key="widget.$ID"
          :is="widget.$Type"
          :readonly="readonly"
          :model="widget"
          :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
export default {
  mixins: [mixin, inputMixin],
  data: () => ({
    panels: []
  }),
  mounted() {
    let intexPanel = this.getDataSourceField(this.model.CurrentPanel) 
    if (intexPanel === undefined) {
      return
    }

    if (this.model.Multiple) {
      this.panels.push(+intexPanel)
      return
    }

    this.panels = +intexPanel
  },
  computed: {
    panelItems() {
      return this.model.PanelItems || []
    }
  }
}
</script>